"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BucketAlreadyOwnedByYou = {
    type: "structure",
    required: [],
    members: {},
    exceptionType: "BucketAlreadyOwnedByYou"
};
//# sourceMappingURL=BucketAlreadyOwnedByYou.js.map